import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { desktop } from "theme/breakpoints";

export const StyledView = styled.div`
  position: relative;
  min-height: 100%;

  display: flex;

  flex-direction: column;
  ${desktop(css`
    flex-direction: row;
  `)}
`;

export const StyledContents = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;
